import { Component, OnInit, signal } from '@angular/core';
import { SignupEventService } from '../serviceLayer/signup-event.service';
import { SharedService } from '../serviceLayer/shared.service';
import { SharedApiService } from '../serviceLayer/shared-service';
import Swal from 'sweetalert2';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  hideFooter = signal(false);
  contact    = signal('');
  message    = signal<{ text: string; type: string; icon: string }>({ text: '', type: '', icon: '' });
  currentYear: number = new Date().getFullYear();

  constructor(
    private signupEventService: SignupEventService,
    private sharedService: SharedService,
    private sharedApiService: SharedApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sharedService.hideFooter$.subscribe(() => {
      this.hideFooter.set(false);
      setTimeout(() => this.hideFooter.set(true), 1000);
    });

    setTimeout(() => this.hideFooter.set(true), 1000);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => this.clearMessage());
  }

  clearMessage() {
    this.message.set({ text: '', type: '', icon: '' });
    this.contact.set('');
  }

  activateSignUpPopUp(isEnable: boolean) {
    this.signupEventService.emit(isEnable);
  }

  private readonly emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  subscribeBtn() {
    const email = this.contact().trim();

    if (!email) {
      this.message.set({ text: 'Please Enter Your Email .', type: 'text-warning', icon: 'fa-solid fa-circle-exclamation' });
      return;
    }

    if (!this.emailRegex.test(email)) {
      this.message.set({ text: 'Please enter a valid email address.', type: 'text-danger', icon: 'fa-solid fa-circle-xmark' });
      return;
    }

    const payload = { contact: email };
    this.sharedApiService.subscribe(payload).subscribe({
      next: (response: any) => {
        if (response?.status) {
          this.contact.set('');
          this.message.set({ text: response?.message || 'Subscribed successfully!', type: 'text-success', icon: 'fa-solid fa-circle-check' });
        } else {
          this.message.set({ text: response?.message || 'Invalid Email Format.', type: 'text-info', icon: 'fa-solid fa-circle-exclamation' });
        }
      },
      error: () => {
        this.message.set({ text: 'Something went wrong. Please try again later.', type: 'text-danger', icon: 'fa-solid fa-circle-xmark' });
      },
    });
  }
}
